/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spicy_Bald_Worm_EndureInputs */

const fr_spicy_bald_worm_endure = /** @type {(inputs: Spicy_Bald_Worm_EndureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour gérer tes notifications. Active, désactive, supprime des navigateurs ou tu souhaite gérer les notifications.`)
};

/**

* @param {Spicy_Bald_Worm_EndureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spicy_bald_worm_endure = /** @type {((inputs?: Spicy_Bald_Worm_EndureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spicy_Bald_Worm_EndureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spicy_bald_worm_endure(inputs)
});